import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { cn, formatPrice } from "@/lib/utils";
import type { StoreOrder } from "@medusajs/types";

type OrderSummaryFooterProps = {
  className?: string;
  locale: Locales;
  order: StoreOrder;
};

const OrderSummaryFooter = ({ className, locale, order }: OrderSummaryFooterProps) => {
  return (
    <dl className={cn("border-primary-light/50 border-t pt-5", className)}>
      <div className="flex items-center justify-between">
        <dd className="text-primary-light">{__("Total VAT exc.", locale)}</dd>
        <dt>{formatPrice(order?.item_subtotal)}</dt>
      </div>
      {order?.discount_total && (
        <div className="flex items-center justify-between">
          <dd className="text-primary-light">{__("Promo code", locale)}</dd>
          <dt> -{formatPrice(order?.discount_total || 0)}</dt>
        </div>
      )}
      <div className="flex items-center justify-between">
        <dd className="text-primary-light">{__("VAT (21%)", locale)}</dd>
        <dt>{formatPrice(order?.tax_total)}</dt>
      </div>
      <hr className="border-primary-light/50 my-5" />
      <div className="flex items-start justify-between">
        <dd className="leading-h1 text-lg font-semibold">
          {__("Total VAT", locale)}* <br />
          <span className="text-primary-light text-xs font-normal">{__("Shipping costs not included", locale)}</span>
        </dd>
        <dt className="text-xl font-semibold">{formatPrice(order?.total)}</dt>
      </div>
    </dl>
  );
};

export default OrderSummaryFooter;
